<ds-actions-header [title]="translation.titleHeader" [actions]="actions()" />
